export function SET_PRESERVED_SELECTED(state, item) {
  state.preservedSelected = item;
}
